import XEUtils from 'xe-utils'
export default {
  name: 'ReconciliationTableMixin',
  data() {
    return {
      loading: false,
      defaultGridOptions: {
        loading: true,
        stripe: true,
        resizable: true,
        autoResize: true,
        showHeaderOverflow: true,
        showOverflow: true,
        size: 'mini',
        columns: [],
        data: [],
        // loading: this.loading,
        pagerConfig: {
          total: 0,
          currentPage: 1,
          pageSize: 20,
          pageSizes: [20, 50, 100],
          autoHidden: false,
          layouts: ['PrevPage', 'Number', 'PageCount', 'NextPage', 'Jump', 'Sizes', 'Total'],
        },
        rowConfig: { isHover: true },
        checkboxConfig: {
          highlight: true, // #e6f7fe
        },
        radioConfig: {
          //   trigger: 'row',
          //   strict: false,
          highlight: true, // #e6f7fe
        },
        footerCellClassName: ({ $rowIndex, column, columnIndex, $columnIndex }) => {
          if ($columnIndex === 0) {
            return 'footer-sum-cell'
          }
        },
        footerMethod: ({ columns, data, $grid }) => {
          const { params: { sumColumnKeys }} = $grid
          const selectRecords = $grid.getCheckboxRecords()
          const sumChecked = selectRecords && selectRecords.length > 0
          const sumData = sumChecked ? [...selectRecords] : [...data]
          return [
            columns.map((column, columnIndex) => {
              if (columnIndex === 0) {
                return sumChecked ? '选中合计' : '本页合计'
              }
              if (sumColumnKeys.includes(column.property)) {
                return this.formatAmount(XEUtils.sum(sumData, column.property))
              }
              return null
            }),
            // columns.map((column, columnIndex) => {
            //   if (columnIndex === 0) {
            //     return '全部合计'
            //   }
            //   if (sumColumnKeys.includes(column.property)) {
            //     return this.formatAmount(XEUtils.sum(data, column.property))
            //   }
            //   return null
            // })
          ]
        }
      },

    }
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    // 预处理列表列配置
    preprocessColumns(columns = [], options = {}) {
      const { checkbox = {}, radio = {}, sequence = {}, operation = {}, sumColumnKeys = [], percentColumnKeys = [], showFooter, sortFront } = options
      let arr = []
      // TODO: 优化checkbox宽度
      if (showFooter) {
        const resize = (obj) => {
          const totalColWidth = 70
          if (obj && obj.width && obj.width > totalColWidth) {
            return obj.width
          }
          return totalColWidth
        }
        if (checkbox.show) {
          checkbox.width = resize(checkbox)
        } else if (radio.show) {
          radio.width = resize(radio)
        }
      }
      if (columns && columns.length) {
        const fixedColumns = columns.filter(i => i.fixed === 'left')
        sequence.fixed = fixedColumns && fixedColumns.length ? 'left' : ( sequence.fixed||'');
      }
      const rad = this.processRadio(radio)
      const box = this.processCheckbox(checkbox)
      const seq = this.processSequence(sequence)
      const opt = this.processOperation(operation)
      if (rad) {
        arr.push(rad)
      } else if (box) {
        arr.push(box)
      }
      if (seq) {
        arr.push(seq)
      }

      if (columns && columns.length) {
        arr = arr.concat(this.processColumns(columns, sumColumnKeys, percentColumnKeys, sortFront))
      }
      if (opt) {
        arr.push(opt)
      }
      return arr
    },
    // 预处理列表--单选列
    processRadio(option) {
      const { fixed = 'left', show = false, width = 50 } = option
      if (show) {
        return {
          type: 'radio', width, fixed
        }
      }
    },
    // 预处理列表--多选列
    processCheckbox(option) {
      const { fixed = 'left', show = false, width = 50 } = option
      if (show) {
        return {
          type: 'checkbox', width, fixed
        }
      }
    },
    // 预处理列表--序列
    processSequence(option) {
      const { fixed = '', show = true, width = 50 } = option
      if (show) {
        return {
          ...option,
          type: 'seq',
          title: '序号',
          width: width,
          fixed,
        }
      }
    },
    // 预处理列表--操作列
    processOperation(option) {
      const { title = '操作', width = 140, fixed = 'right', show = true } = option
      if (show) {
        return { title, width, fixed, slots: { default: 'operate' }}
      }
    },
    // 预处理列表--数据列
    processColumns(columns, sumKeys, percentColumnKeys, sortable) {
      return columns.map(i => {
        if (i.title) {
          if (sumKeys.includes(i.field)) {
            i.formatter = this.formatAmount
            i.align = 'right'
            if (sortable) {
              i.sortable = sortable
              i.sortBy = i.field
            }
          }
          if (percentColumnKeys.includes(i.field)) {
            i.formatter = this.formatPercent
          }
          // i.headerAlign = 'left'
        }
        return i
      })
    },
    // 保留6位小数
    toFixed(value) {
      // if (isNaN(value)) {
      //   return value
      // }
      // const decimalPointIndex = `${value}`.indexOf('.')
      // if (decimalPointIndex !== -1) {
      //   value = `${value}`.substring(0, decimalPointIndex + 3)
      //   return Number(value)
      // }
      // return value
    },
    // 四舍五入金额，每隔3位逗号分隔，默认2位数
    formatAmount(data, digits = 2, cvt = false) {
      if (!XEUtils.isUndefined(data)) {
        let decimal = 0
        if (XEUtils.isFinite(data)) {
          decimal = data
        } else if (data && XEUtils.isFinite(data.cellValue)) {
          decimal = data.cellValue
        } else {
          return ''
        }
        if (cvt && digits > 2) {
          if (Number.isInteger(decimal)) {
            return XEUtils.commafy(XEUtils.toNumber(decimal), {
              digits: 2,
              round: false,
              ceil: false,
              floor: false
            })
          } else {
            const str = decimal.toString()
            const len = str.substring(str.indexOf('.') + 1).length
            return XEUtils.commafy(XEUtils.toNumber(decimal), {
              digits: len > 2 ? digits : 2,
              round: false,
              ceil: false,
              floor: false
            })
          }
        } else {
          return XEUtils.commafy(XEUtils.toNumber(decimal), { digits, round: false, ceil: false, floor: false })
        }
      }
      return data
    },
    formatPercent(data) {
      const { cellValue: decimal } = data
      if (!XEUtils.isUndefined(decimal) && XEUtils.isFinite(decimal)) {
        return `${XEUtils.multiply(decimal, 100)}%`
      }
      return decimal
    },
  }
}
